module["exports"] = [
  "082 ### ####",
  "083 ### ####",
  "085 ### ####",
  "086 ### ####",
  "087 ### ####",
  "089 ### ####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_IE/cell_phone/formats.js
// module id = 1116
// module chunks = 0